import React from 'react'

import { useCountdownFSBonusStore } from '@stores'
import { BSModalButton } from '@components'
import { useTranslation } from '@amusnet/translations/react'
import { BonusSystemState, CountdownFSBonusEndModalButtonClickedMessage, GameUIMessageType } from 'game-ui-types'

const CFSEndButtons: React.FC = () => {
    const setBonusSystemState = useCountdownFSBonusStore((state) => state.setBonusSystemState)
    const setActiveBonus = useCountdownFSBonusStore((state) => state.setActiveBonus)
    const activeBonus = useCountdownFSBonusStore((state) => state.activeBonus)

    const { t } = useTranslation()

    const okButtonHandler = () => {
        setActiveBonus(undefined)
        setBonusSystemState(BonusSystemState.INACTIVE)

        const bonusEndModalButtonClickedMessage: CountdownFSBonusEndModalButtonClickedMessage = {
            type: GameUIMessageType.COUNTDOWN_FS_BONUS_END_MODAL_BUTTON_CLICKED,
            bonusId: activeBonus?.id ?? '',
        }

        window.postMessage(bonusEndModalButtonClickedMessage)
    }

    return (
        <div className="flex flex-col items-center w-full py-[10px]">
            <BSModalButton id="freespin-bonus-ok" text={t('gameui.ok')} onClick={okButtonHandler} />
        </div>
    )
}

export default CFSEndButtons
